import { render, staticRenderFns } from "./sendBoardMessage.vue?vue&type=template&id=350f78fc&scoped=true&"
import script from "./sendBoardMessage.vue?vue&type=script&lang=js&"
export * from "./sendBoardMessage.vue?vue&type=script&lang=js&"
import style0 from "./sendBoardMessage.vue?vue&type=style&index=0&id=350f78fc&prod&lang=css&"
import style1 from "./sendBoardMessage.vue?vue&type=style&index=1&id=350f78fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350f78fc",
  null
  
)

export default component.exports